module.exports = __webpack_public_path__ + "img/terry-gallery-4.5492cb5f.jpg";